import { GridView } from "../Components/GridView";
import "../Globals/Extenders/UpdateCartQty";
import "../Globals/Extenders/TrackChange";
import { AjaxPost } from "../Services/index";
import { ItemRowModel } from "../ViewModels/Products/Models/ItemRowModel";
import { CartHeaders, CartItem, RequestQuote, RequestReview } from './index';
import { ICartData } from './types/ICartData';
import { ICartRowItem } from "./types/ICartRowItem";
import { IPromoResponseModel } from "./types/IPromoResponseModel";
import { Slugify, UrlSegments } from "../Helpers/index";
import { DataLayerModelFactory, DataLayerTxItem, CartData } from "../Services/DataLayer/index";
import { CustomPopover_clickSelect } from "../Components/CustomPopover_clickSelect";

CustomPopover_clickSelect();
export class ActiveCart {

    private Row: ItemRowModel = new ItemRowModel();

    protected LocalKey: string
        = typeof localStorage.getItem("CartSessionKey") != 'undefined' ? localStorage.getItem("CartSessionKey") : "RequestNewKey";
    private CartOrderID: KnockoutObservable<string>
        = typeof this.LocalKey != 'undefined' ? ko.observable(this.LocalKey) : ko.observable("88888888");

    public CartItems: KnockoutObservableArray<CartItem> = ko.observableArray(null);
    public Grid: GridView = new GridView({
        Data: this.CartItems,
        UseFilter: true,
        FilterCriteria: ["ItemID", "Description"],
        GridTemplateName: "activeCart",
        Columns: [
            { headerText: "Unit Price", rowText: "UoMPrice", cssD: "col-2 text-center" },
            { headerText: "Qty", rowText: "QtyOrdered", cssD: "col-1 text-center" },
            { headerText: "Ext. Price", rowText: "PriceExtension", cssD: "col-1 text-right" }
        ],
        PageSize: 30,
        PagerPos: "top"
    });

    private ItemsOnAlt: KnockoutObservableArray<any> = ko.observableArray([])
    public HasPromoCode: KnockoutObservable<boolean> = ko.observable(false);
    public CanUsePromoCode: KnockoutObservable<boolean> = ko.observable(false);
    private PromoLoading: KnockoutObservable<boolean> = ko.observable(false);
    private PromoMessage: KnockoutObservable<string> = ko.observable();
    private PromoDiscount: number;
    public PromoCode: KnockoutObservable<string> = ko.observable(null);
    private PromoItem: KnockoutObservable<any> = ko.observable(null);
    public TotalSumSavings: KnockoutObservable<number> = ko.observable(0.00);
    public TotalContractSavings: KnockoutObservable<number> = ko.observable(0.00);
    public TotalPromoSavings: KnockoutObservable<number> = ko.observable(0.00);
    public TotalCartSum: KnockoutObservable<number> = ko.observable(0.00);
    public TotalCartSubtotal: KnockoutObservable<number> = ko.observable(0.00);

    public HiglightSelectedAltItem = (data) => {
        localStorage.setItem('LastSearchTerm', data.ItemID)
        window.open(data.ProductUrl);
    }

    private RemovePromoClick = () => {
        let cartVM = (<any>window).cartVM;
        let header = (<any>cartVM).header;
        let self = this;
        let promoItem = self.PromoItem();

        if (!promoItem) {
            return;
        }

        if (self.HasPromoCode() && header.Promo() !== null) {
            self.PromoLoading(true);
            header.Promo(null);
            self.HasPromoCode(false);
            self.PromoCode(null);
            self.PromoItem(null);
            self.RemovePromo(header, promoItem)
                .then(self.ProcessPromoCodeUI);
        }
    };
    private ApplyPromo = () => {
        let cartVM = (<any>window).cartVM;
        let header = (<any>cartVM).header;
        let self = this;
        let promocode = self.PromoCode();

        if (!promocode) {
            return;
        }

        if (!self.HasPromoCode() && header.Promo() === null) {
            self.PromoLoading(true);
            self.HasPromoCode(true);
            self.ValidatePromo(header, self.PromoCode())
                .then(self.ProcessPromoCodeUI);
        }
    };

    private ValidatePromo = (header: CartHeaders, promoCode: string) => {
        let self = this,
            cartID: string = self.CartOrderID();
        let cartDiscounts = ko.toJS(self.CartDiscounts());

        return new Promise((resolve, reject) => {
            new AjaxPost({
                endpoint: '/ShoppingCart/ValidatePromoCode',
                payload: JSON.stringify(
                    {
                        promoCode: promoCode,
                        cartOrderID: cartID
                    }),

                cbFunction: function (response: ICartData) {
                    self.PromoMessage(response.Messages);
                    self.PromoLoading(false);
                    self.PromoDiscount = cartDiscounts - self.CartDiscounts();

                    let cartData = JSON.parse(JSON.stringify(response));
                    header.ParseCartData(cartData);
                    self.LoadCartItems(header);
                    resolve(response);
                },

                errFunction: function (err: any) {
                    self.PromoMessage = err.toString().trim();
                    self.PromoLoading(false);
                    reject(err);
                }
            });
        })

    }
    private RemovePromo = (header: CartHeaders, promoItem: ICartRowItem) => {

        let self = this,
            promoCode: KnockoutObservable<string> = self.PromoCode,
            // Store this promo code in a shallow copy object for rollback
            _promoCode: any = { ...promoCode };

        return new Promise((resolve, reject) => {

            new AjaxPost({
                endpoint: '/ShoppingCart/EditCart',
                payload: JSON.stringify({
                    item: promoItem,
                    action: "remove"
                }),

                cbFunction: function (response: ICartData) {
                    self.PromoLoading(false);

                    self.PromoMessage(response.Messages);
                    self.PromoLoading(false);
                    self.PromoDiscount = 0;
                    let cartData = JSON.parse(JSON.stringify(response));
                    header.ParseCartData(cartData);
                    self.LoadCartItems(header);
                    resolve(response);
                },

                errFunction: function (err) {
                    // Re-apply the promo code if something went wrong
                    self.PromoCode(_promoCode());
                    self.ValidatePromo(header, _promoCode());
                    self.PromoLoading(false);
                    reject(err);
                }
            });
        })

    }
    // Promocode UI post-processing
    private ProcessPromoCodeUI = (() => {
        let cartVM = (<any>window).cartVM;
        let header = (<any>cartVM).header;
        if (cartVM.activeCart.CartItems().length === 0) { return; }
        let promoResponse = header.LatestCartObject().PromoResponseModel;
        let self = this;
        let promoObject: KnockoutObservable<CartItem> = header.Promo,
            promoType: string;

        $('.item-qty').each((i, el) => { $(el).find('input').prop('disabled', self.HasPromoCode()) });
        if (promoObject()) {
            promoType = promoObject().UoMDesc.toString().trim();

            if (promoType.toString() === "PP" || promoType.toString() === "DD" || promoType.toString() === "NN") {
                if (promoType.toString()) {

                    self.PromoCode(promoObject().Heading);
                    self.PromoItem(promoObject())
                    self.HasPromoCode(true);

                    promoObject().ListPrice = 0.00;

                }
                self.PromoCode(promoObject().Heading);
                self.PromoItem(promoObject())
                self.HasPromoCode(true);
            }
        }

        $("#promoInput").prop('placeholder', "enter promo code to receive a discount");
        $("#promo-status-message").html("<small>Only one promo code per order transaction will be applied.</small>");

        if (promoResponse.IsPromoCodeExist == false) {
            $("#promoInput").prop('placeholder', promoResponse.PromoResponseMsg + " Try again?");
        }
        else {
            if (promoResponse.IsPromoValid == false)
                $("#promo-status-message").html("<small class='text-danger'>" + promoResponse.PromoResponseMsg + "</small>");
        }
    });

    private HandlePromo = (() => {
        let cartVM = (<any>window).cartVM;
        let header = (<any>cartVM).header;
        let promoResponse = header.LatestCartObject().PromoResponseModel;
        let self = this;
        let promoObject: KnockoutObservable<CartItem> = header.Promo,
            promoType: string;
        $('.item-qty').each((i, el) => { $(el).find('input').prop('disabled', self.HasPromoCode()) });

        if (promoObject()) {
            promoType = promoObject().UoMDesc.toString().trim();

            if (promoType.toString() === "PP" || promoType.toString() === "DD" || promoType.toString() === "NN") {
                if (promoType.toString()) {


                    promoObject().ListPrice = 0.00;
                }
                self.PromoCode(promoObject().Heading);
                self.PromoItem(promoObject())
                self.HasPromoCode(true);
            }
        }

        // Reset default promo messages
        $("#promoInput").prop('placeholder', "enter promo code to receive a discount");
        $("#promo-status-message").html("<small>Only one promo code per order transaction will be applied.</small>");

        // Defines promo success/error message
        let msg: string,
            errMsg: string;

        if (typeof self.PromoMessage() != 'undefined') {
            msg = self.PromoMessage().split('Success: ')[1];
            errMsg = self.PromoMessage().split('Error: ')[1];
        }

        if (promoResponse.PromoResponseMsg != "" && !promoResponse.IsPromoValid) {
            $("#promo-status-message").html("<small class='text-danger'>" + promoResponse.PromoResponseMsg + "</small>");
        }

        if (!msg) {
            if (errMsg === "Invalid promo code.") // If it's this error, display in input placeholder
                $("#promoInput").prop('placeholder', errMsg + " Try again?");
            else if (errMsg) {
                $("#promo-status-message").html("<small class='text-danger'>" + promoResponse.PromoResponseMsg + "</small>");
            }
        }
    });

    public CartSubtotal = ko.computed(function () {
        //we don't display the cartsubtotal from this method
        return 0;
    }, this);
    private CartDiscounts = ko.computed(() => {
        //we don't display the discounts from this method
        return 0;
        //return cartDiscounts;
    }, this);

    private CumulativeSavings = ko.computed(function () {
        //we don't use this results on the cart page
        return 0;
    }, this);

    public GrandTotal = ko.computed(() => {
        //this is Grand total shown on the first review cart page        
        return this.TotalCartSubtotal();
    }, this);

    public PromoDolarDiscountTotal = ko.computed(() => {

        let dollarDiscount = 0.00;
        if (this.PromoItem() !== null && this.PromoItem().UoMDesc.toString().trim() === "DD") {
            dollarDiscount = this.PromoItem().PriceExtension;
        }
        return dollarDiscount;
    }, this);

    private PopupImage: KnockoutObservable<string> = this.Row.PopupImage;
    private LoadPopupImage = this.Row.LoadPopupImage
    private StockStatus = this.Row.StockStatus
    private ProcessLineItems(item: ICartRowItem) {
        let self = this;
        if (typeof item != 'undefined') {

            let cartItem = new CartItem();
            cartItem.ImageUrl =
                typeof item.ImageUrl != 'undefined' ? // Replace with path to higher resolution thumbnails
                    item.ImageUrl !== null ? item.ImageUrl.split("/")[4] : null : null;
            cartItem.ImgSrc =
                typeof item.ImageUrl != 'undefined' ? // Replace with path to higher resolution thumbnails
                    item.ImageUrl !== null ? "/Content/ProductImages/80x60/" + item.ImageUrl.split("/")[4] : null : null;

            cartItem.ProductUrl = (item.ItemGroupRecNo === -1 || item.ItemGroupRecNo === null) ? "javascript:void(0)" : // do nothing if IGRN === -1 or null
                typeof item.Heading != 'undefined' ?
                    item.Heading !== null ? // Append slugified item heading if available, else just use IGRN
                        "/products/details/" + item.ItemGroupRecNo + "/" + Slugify(item.Heading) + "/" :
                        "/products/details/" + item.ItemGroupRecNo + "/" : null;

            cartItem.Rx = item.RxProduct === "N" ? null : item.Rx;
            cartItem.ItemID = item.ItemID;
            cartItem.ItemGroupRecNo = item.ItemGroupRecNo;
            cartItem.OrderItemRecNo = item.OrderItemRecNo;
            cartItem.Description = item.Description;
            cartItem.UoMDesc = item.UoMDesc;
            cartItem.UoMPackSize = item.UoMPackSize;
            cartItem.UoM = item.UoMDesc + "-" + item.UoMPackSize;
            cartItem.ListPrice = parseFloat(item.ListPrice.toFixed(2));
            cartItem.PercDiscount = item.PercDiscount;
            cartItem.AltItemList = item.AltItemList;
            cartItem.UnitPrice =
                typeof item.UoMPrice != 'undefined' ?
                    item.UoMPrice !== null ? parseFloat(item.UoMPrice.toFixed(2)) : null : null;


            cartItem.QuantityOrdered = ko.observable(item.QtyOrdered)
                .extend({
                    UpdateCartQty: item,
                    trackChange: true
                    // Extended observable, triggers 1.25 seconds after the last change in value
                    //rateLimit: { timeout: 800, method: "notifyWhenChangesStop" }
                });

            cartItem.FinalPrice = ko.pureComputed(function () {
                return item.UoMPrice * item.QtyOrdered; //cartItem.QuantityOrdered();
            });

            cartItem.Heading = item.Heading;
            cartItem.VendName = item.VendName;
            cartItem.VendItemNo = item.VendItemNo;
            cartItem.AvaleraTaxCode = item.AvaleraTaxCode;
            cartItem.ALERTExpStatus = item.ALERTExpStatus;
            cartItem.ALERTOrgDate = item.ALERTOrgDate;
            cartItem.ALERTStatus = item.ALERTStatus;
            cartItem.AlertType = item.AlertType;
            cartItem.ALERTUpdateDate = item.ALERTUpdateDate;
            cartItem.INFOEstShipDate = item.INFOEstShipDate;
            cartItem.Status = item.Status;
            self.CartItems.push(cartItem);
        };

        self.CartOrderID(self.LocalKey);
    }
    private LoadCartItems = function (header: CartHeaders) {
        let self = this;

        if (header.CartItems()) {
            console.debug("Line items to load in Active Cart", ko.unwrap(header.CartItems()).length);
            self.CartItems([]);
            self.CanUsePromoCode(header.IsPromoUser());
            self.TotalSumSavings(header.TotalSumSavings());
            self.TotalContractSavings(header.TotalContractSavings());
            self.TotalPromoSavings(header.TotalPromoSavings());
            self.TotalCartSubtotal(header.TotalCartSubtotal());
            ko.toJS(header.CartItems()).forEach((item: any) => {
                self.ProcessLineItems(item);
            });

            if (header.Promo()) {

                let promoItem: any = header.Promo,
                    promoCode = promoItem().Heading !== null ? promoItem().Heading : null;

                self.PromoCode(promoCode);
                self.PromoItem(promoItem());
                self.HasPromoCode(true);
            }

            if (window.location.pathname !== '/ShoppingCart/Checkout') {
                if (header.Promo() === null) {
                    self.PromoCode(null);
                    self.PromoItem(null);
                    self.PromoLoading(false);
                    self.HasPromoCode(false);
                }

            }
            console.info("Active Cart loaded")
        }

        else {
            console.info("No items in active cart")
        }

    };
    private RemoveItem = (data, event) => {

        let cartVM = (<any>window).cartVM;
        let header = (<any>cartVM).header;
        let self = this;
        if (!data || !event)
            return;
        let item = {
            OrderItemRecNo: data.OrderItemRecNo,
            CartOrderID: self.CartOrderID(),
            ItemID: data.ItemID,
            UoM: data.UoMDesc + "-" + data.UoMPackSize,
            QtyOrdered: 0
        },
            ajaxConfig = {
                endpoint: '/ShoppingCart/EditCart',
                payload: JSON.stringify({
                    item: item,
                    action: "update"
                }),

                cbFunction: function (response) {
                    header.ParseCartData(response);

                    //This is only called when you click the remove button on the cart and not the (- button on qty)                    

                    let error = response.Messages.split(':')[0] === 'Error',
                        msgBody = error ? JSON.stringify(response) : response.Messages.split(':')[1];

                    let gridRowIndex = self.CartItems().map(function (x) { return x.OrderItemRecNo; }).indexOf(item.OrderItemRecNo);

                    if (gridRowIndex >= 0) {
                        // Splice out the row from the arrays that hold it
                        self.CartItems().splice(gridRowIndex, 1);
                        self.CartItems.valueHasMutated();
                    }
                    if (response.NumOfItems == 0) {
                        //Removed cart's last item

                        let link = $('<a>our product categories.</a>').attr({
                            'href': '/products/',
                            'style': 'text-decoration:underline'
                        }),
                            msg = $('<span>Cart is empty. Start browsing </span>').append(link);

                        $('#empty-cart-alert').empty().append(msg);
                        $('#active-cart').hide();

                        $('#cart-order-number').text('');
                        $('#cart-order-number-label').hide();
                        localStorage.removeItem("CartSessionKey");
                    }
                    self.ProcessPromoCodeUI();
                },

                errFunction: function (err) {
                    console.debug("UpdateItemQty error message", err);
                }
            };

        new AjaxPost(ajaxConfig);
    }
    private UpdateQty = this.Row.UpdateQty

    private PreventCheckout: KnockoutComputed<boolean> = ko.pureComputed(function () {
        let cartVM = (<any>window).cartVM;
        let header = (<any>cartVM).header;
        if (header.RxCheck() === "RxPersonal")
            return true;
        if (header.UserLocked())
            return true;
        else
            return false;

    })

    private RxCheck: KnockoutComputed<string> = ko.computed(function () {
        let cartVM = (<any>window).cartVM;
        let header = (<any>cartVM).header;
        return header.RxCheck();
    })

    private ReqQuoteVM;
    private RequestReviewVM;

    constructor(header: CartHeaders, model) {
        const self = this;
        let cartVM = window.cartVM;
        cartVM.activeCart = self;
        self.LoadCartItems(header);
        self.ProcessPromoCodeUI();
        // Promo code input [Enter] keypress event listener
        $(document).on("keypress", "#promoInput", function (event) {

            if (event.keyCode === 13) {
                if (!self.HasPromoCode())
                    document.getElementById("btn-promo-apply").click();
                else if (self.HasPromoCode())
                    document.getElementById("btn-promo-remove").click();
            }
        });

        // Quote Requested UI changes
        function processQuoteRequestUI() {
            if (header.QuoteRequested) {
                $('#request-quote-partial')
                    .find('button').first()
                    .find('span').first().text('Submit a change request for Quote');
                $('#request-quote-form').find('.text-info').first()
                    .text('Please allow one business day for a response to your quote modification request.');
            }
        }
        function disableInputs() {
            if (header.QuoteRequested) {
                $('.number-spinner').each((i, el) => { $(el).hide() });
                $('.number-spinner-disabled').each((i, el) => { $(el).show() });
                $('.link-remove-item').each(function (i, el) { $(el).hide() });
                $('.item-qty').each(function (i, el) { $(el).find('input').prop('disabled', true) });
            }
        }

        if (header.LocalKey()) {
            $('#cart-order-number').text(header.LocalKey());
            $('#cart-order-number-label').show();
            processQuoteRequestUI();
        }

        function displayCallToAction() {
            let link = $('<a>our product categories.</a>').attr({
                'href': '/products/',
                'style': 'text-decoration:underline'
            }),
                msg = $('<span>Cart is empty. Start browsing </span>').append(link);
            $('#empty-cart-alert').empty().append(msg);
            $('#active-cart').hide();
        }

        $(() => {
            // If cart is empty, encourage user to browse product categories. 
            // We can add code here later to customize what categories to promote.
            if (!window.localStorage.getItem("CartSessionKey")) {
                displayCallToAction();
            } else if (header.CartItems().length === 0) {
                displayCallToAction();
            }

            // Clear preloader, toggle tooltips
            self.Grid.Data.subscribe((change) => {
                if (change) {
                    if (change.length) {
                        $('.preloader').hide();
                        $('[data-toggle="tooltip"]').tooltip();
                        disableInputs();
                    }
                }
            })

            self.Grid.PageIndex.subscribe((change) => {
                $('[data-toggle="tooltip"]').tooltip();
            })

            $(document).ajaxStop(() => {
                processQuoteRequestUI();
                disableInputs();
            });

            header.SavedCarts.subscribe((change) => {
                $('.preloader').hide();
            })

            // Begin Cart Extensions
            if (model.HasQuotePermissions || model.SendForReview) {
                ko.validation.init({
                    registerExtenders: true,
                    decorateInputElement: true,
                    parseInputAttributes: true,
                    writeInputAttributes: true,
                    errorElementClass: 'is-invalid',
                    errorMessageClass: 'invalid-tooltip',

                    insertMessages: true,
                    messagesOnModified: false,
                    messageTemplate: null,
                    grouping: { live: true },
                }, true);
            }

            function limitCharCount(fieldTag: string, counterTag: string) {
                let maxChars = $(fieldTag);
                let max_length = parseInt(maxChars.attr('maxlength'));
                if (max_length > 0) {
                    maxChars.bind('keyup', function (e) {
                        let length = (maxChars.val().toString()).length;
                        let counter = max_length - length;
                        $(counterTag).text(counter);
                    });
                }
            }

            if (model.HasQuotePermissions) {

                self.ReqQuoteVM = ko.validatedObservable(new RequestQuote())();

                ko.cleanNode(document.getElementById('request-quote-partial'));
                ko.applyBindings(self.ReqQuoteVM, document.getElementById('request-quote-partial'));

                limitCharCount("#Comment", "#QuoteCommentCounter");

            }

            if (model.SendForReview) {
                self.RequestReviewVM = ko.validatedObservable(new RequestReview(model.AddressBook))();
                ko.cleanNode(document.getElementById('request-review-partial'));
                ko.applyBindings(self.RequestReviewVM, document.getElementById('request-review-partial'));
                limitCharCount("#ReviewComment", "#ReviewCommentCounter");
            }
        })

        // Analytics data layer implementation
        $(() => {

            let products = ko.observableArray([]);
            let analyticsUpdate = (items) => {
                //let Items = self.CartItems;

                if (items.length) {
                    let latestItemsInCart = items.map((obj, index) => {
                        return {
                            brand: obj.VendName,
                            id: obj.ItemID,
                            category: obj.Heading,
                            name: obj.Description,
                            quantity: obj.QuantityOrdered(),
                            price: obj.PriceExtension || obj.ListPrice,
                            variant: obj.UoM,
                            position: index
                        }
                    });

                    let cartData: CartData = {
                        id: self.CartOrderID(),
                        subTotal: self.CartSubtotal(),
                        step: 1,
                        coupon: self.HasPromoCode() ? self.PromoCode() : "N/A"
                    }

                    products(latestItemsInCart);

                    let analytics = new DataLayerModelFactory().checkout(products(), cartData);
                    console.debug("dataLayer impressions change: ", products());
                    window.dataLayer.push(analytics);
                }
            }

            // Rest of code does not apply on checkout page
            if (UrlSegments(1) === "Checkout") {
                return;
            }

            // Trigger on DOM ready, then everytime cart items change value
            analyticsUpdate(self.CartItems());

            self.CartItems.subscribe((change) => {
                analyticsUpdate(change);
            })

            // Intercept xhr options.url === "/ShoppingCart/EditCart" success response.Messages data to determine add/remove products in cart
            // Sample object property: { Messages: "Success: BA3545 has been updated to 4 units of ea-1." }

            $(document).ajaxComplete((event, xhr, options) => {
                if (options.url !== "/ShoppingCart/EditCart") {
                    return;
                }
                //THIS IS CALLED IF YOU TOGGLE THE +/- ON THE CART ONLY!
                let response = xhr.responseJSON;

                if (response) {
                    if (response.Messages) {
                        let success = response.Messages.split(":")[0].trim() === "Success";
                        if (!success) {
                            return;
                        }
                    }
                }

                let message = response.Messages;
                let itemID = message.split(":")[1].trim().split(" ")[0];
                let UoM = message.split(":")[1].trim().split(" ").slice(-1)[0];
                console.debug("Cart update ItemID: ", { itemID, UoM, message });

                let allProducts = self.CartItems();
                let originalItem: ICartRowItem = Object.assign({}, allProducts.find(function (item) {
                    return item.ItemID === itemID;
                }));

                let product: DataLayerTxItem = new DataLayerTxItem();
                Object.assign(product, products().find(function (item) {
                    return item.id === itemID;
                }));
                console.debug("dataLayer product: ", { product, originalItem });

                if (originalItem.QuantityOrdered) {
                    let diff = <any>originalItem.QuantityOrdered - product.quantity;
                    if (diff > 0) {
                        product.quantity = Math.abs(diff);
                        console.debug("Item added: ", product);
                        window.dataLayer.push(new DataLayerModelFactory().addToCart(product));
                    }
                    if (diff <= 0) {
                        product.quantity = ~diff + 1;
                        console.debug("Item removed: ", product);
                        window.dataLayer.push(new DataLayerModelFactory().removeFromCart(product));
                    }
                }

                //what does this do if I put it here will it force the screen to update when the promo it invalidated or enabled?
                let cartData = JSON.parse(JSON.stringify(response));
                header.ParseCartData(cartData);
                self.LoadCartItems(header);
                header.ParseCartData(response);
                self.ProcessPromoCodeUI();
            })

        })
    };
}